import whisperingForestSource from "./whispering-forest-source.json";

const FALLBACK_VOID_CAVE_PORTAL = Object.freeze({
  x: 464,
  y: 88,
  width: 96,
  height: 72,
});

const voidCavePortalObject = whisperingForestSource.layers
  .filter((layer) => layer.type === "objectgroup")
  .flatMap((layer) => layer.objects || [])
  .find((object) => object.name === "voidCavePortal");

export const WHISPERING_FOREST_VOID_CAVE_PORTAL_RECT = Object.freeze(
  voidCavePortalObject
    ? {
        x: Number(voidCavePortalObject.x || 0),
        y: Number(voidCavePortalObject.y || 0),
        width: Number(voidCavePortalObject.width || 0),
        height: Number(voidCavePortalObject.height || 0),
      }
    : FALLBACK_VOID_CAVE_PORTAL,
);

export const WHISPERING_FOREST_VOID_CAVE_RETURN_SPAWN = Object.freeze({
  x:
    WHISPERING_FOREST_VOID_CAVE_PORTAL_RECT.x +
    WHISPERING_FOREST_VOID_CAVE_PORTAL_RECT.width / 2,
  y:
    WHISPERING_FOREST_VOID_CAVE_PORTAL_RECT.y +
    WHISPERING_FOREST_VOID_CAVE_PORTAL_RECT.height / 2,
});
